export default __webpack_public_path__ + "static/media/alignment-bottom.1e6ac211.svg";